import { Vue, Component } from 'vue-property-decorator';

@Component
export class SwipeToDismissMixin extends Vue {
  protected swipeY = 0;
  protected isDragging = false;

  protected onSheetPan(event: any): void {
    const y = Math.max(0, event.offset.y);
    if (!event.isFinal) {
      this.isDragging = true;
      this.swipeY = y;
      return;
    }
    this.isDragging = false;
    if (y > 80 || event.velocity.y > 0.4) {
      this.dismissSheet();
    }
    else {
      this.swipeY = 0;
    }
  }

  // Apply to the sheet root element: :style="sheetDragStyle()"
  // Pass false on non-mobile sheets to disable: :style="sheetDragStyle($q.screen.lt.sm)"
  protected sheetDragStyle(active = true): Record<string, string> {
    if (!active) {
      return {};
    }
    return {
      transform: `translateY(${this.swipeY}px)`,
      transition: this.isDragging ? 'none' : 'transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)',
    };
  }

  // Call from the dialog's @hide event to reset state after close animation
  protected onSheetHide(): void {
    this.swipeY = 0;
    this.isDragging = false;
  }

  // Override in each component to close the sheet
  protected dismissSheet(): void {
    // noop — implemented per component
  }
}
